import api from "./api";

export const fetcher = (url) =>
  api.get(url).then((res) => res.data.data);

export const variantFetcher = (url) =>
  api.get(url).then((res) => res.data);

export const cacheFetcher = async (url, minutes = 10) => {
  const key = `cacheFetcher${url}`;
  const expKey = `${key}/exp`;

  const cachedData = localStorage.getItem(key);
  if (cachedData) {
    if (Date.now() < localStorage.getItem(expKey))
      return JSON.parse(cachedData);
  }
  const response = await api.get(url);
  const { data } = response.data;

  localStorage.setItem(key, JSON.stringify(data));
  localStorage.setItem(expKey, Date.now() + 60 * minutes * 1000);
  return data;
};
